import React, { useContext, useEffect, useRef, useState } from "react";
import CustomTooltip from "../../Elements/Tooltip";
import { sanitizeHtml } from "../../../utils/sanitizeHtml";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faPenToSquare,
  faShuffle,
  faXmark,
  faCalendarXmark
} from "@fortawesome/free-solid-svg-icons";
import { Accordion, Col, Row, Table } from "react-bootstrap";
import Switch from "../../Elements/Form/Switch";
import styles from "./links.module.css";
import getRandomString from "../../../utils/getRandomString";
import Select from "../../Elements/Select";
import Input from "../../Elements/Input";
import TextArea from "../../Elements/Form/TextArea";
import Button from "../../Elements/Button";
import customAPIRequest from "../../../utils/customAPIRequest";
import CommonModal from "../../Modals/CommonModal";
import { networkService } from "../../config/axios";
import TextEditorSection from "../../Pages/Kdf/EditKdf/elementModal/elementSections/textEditorSection/TextEditorSection";
import UserInfoContext from "../../../utils/userInfoContext";
import apiGETRequest from "../../../utils/apiRequest";
import {
  DEFAULT_OPTIN_AFTER_PAGES,
  DEFAULT_OPTIN_HEADLINE,
  OPTIN_MODES,
  OPTIN_NOT_A_MAILING_LIST,
  getOptInCopy,
} from "../../../constants/optInDefaults";
import { resolvePrivacyUrl } from "../../../utils/optInGate";
import { loadGoogleFontsInHtml } from "../../../utils/googleFontLoader";
import PersonalInsightsOptinSettings from "./PersonalInsightsOptinSettings";

const hasValue = (v) => v !== "" && v !== null && v !== undefined;

const AccessGateOptionsTab = ({
  editLaserLinkItem,
  updateEditLaserLinkItem,
  time_zone_list,
  getDocFiles,
  defaultLinkTexts,
  updateDefaultLink,
  validationTrigger,
  updateErrorStatus,
  errorListData,
  getProfile
}) => {
  const [individualCodeStatus, setIndividualCodeStatus] = useState(false);
  const [expirationDateStatus, setExpirationDateStatus] = useState(false);
    const [forwardAfterExpirationStatus, setForwardAfterExpirationStatus] = useState(false);
    const [forwardOptionType, setForwardOptionType] = useState("url");

    const DEFAULT_ERROR_TEXT =
        "Sorry, this link is not active.\nPlease inform the person who shared it with you.";
  const [editTextMessage, setEditTextMessage] = useState(false);
  const [deleteTextMessage, setDeleteTextMessage] = useState(null);
  const [accordinActiveKey, setAccordinActiveKey] = useState(null);
  const [customTextScope, setCustomTextScope] = useState('initial');
  const [editTextMessageData, setEditTextMessageData] = useState(null);
  const { setShowNotifications, profileData, userInfoData, companyData } = useContext(UserInfoContext);
  const [isSavingText, setIsSavingText] = useState(false);
  const [templateSaveState, setTemplateSaveState] = useState(null);
  const [editorKey, setEditorKey] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Use profile data from context first (always has data), fallback to props
  const [fetchedProfile, setFetchedProfile] = useState(null);
  const profile = [profileData, getProfile, fetchedProfile].find((item) => item?.first_name) || profileData || getProfile || {};

  useEffect(() => {
    if (profileData?.first_name || getProfile?.first_name || fetchedProfile || !userInfoData?.id) return;
    apiGETRequest(`profiles/${userInfoData.id}.json`).then((data) => {
      if (data && !data.error) setFetchedProfile(data);
    });
  }, [profileData?.first_name, getProfile?.first_name, userInfoData?.id]);
  const userName = `${profile?.first_name ?? ''} ${profile?.last_name ?? ''}`.trim() || profile?.name || '';
  const companyName = profile?.company_name || '';
    useEffect(() => {
        if (editLaserLinkItem?.password != null) {
            setIndividualCodeStatus(true);
        }

        if (editLaserLinkItem?.expiry != null) {
            setExpirationDateStatus(true);
        }
        if (editLaserLinkItem?.forward_settings?.enabled) {
            setForwardAfterExpirationStatus(true);
            setForwardOptionType(
                editLaserLinkItem?.forward_settings?.type ?? "url"
            );
        }
    }, [])

  useEffect(() => {
    updateEditLaserLinkItem({
      ...editLaserLinkItem,
      accessGateOptionStatus: (individualCodeStatus || expirationDateStatus),
    });
    //has_optin
  }, [individualCodeStatus, expirationDateStatus])

  useEffect(() => {
    if (templateSaveState === 'success') {
      const timer = setTimeout(() => setTemplateSaveState(null), 2500);
      return () => clearTimeout(timer);
    }
  }, [templateSaveState]);

  // const validateInnerData = () => {
  //   let errorToUpdate = JSON.parse(JSON.stringify(errorListData));
  //   updateErrorStatus([...errorToUpdate]);
  // }

  const validateInnerData = () => {
  let errs = Array.isArray(errorListData) ? [...errorListData] : [];
  const pages = getDocFiles?.[0]?.num_pages || 0;

  // Expiration ON ⇒ date + time + tz required
  if (expirationDateStatus) {
    if (!editLaserLinkItem?.expiry) {
      if (!errs.includes("expiry_date")) errs.push("expiry_date");
    } else {
      errs = errs.filter(k => k !== "expiry_date");
    }
    const hasTime = typeof editLaserLinkItem?.expire_time === "string" && editLaserLinkItem?.expire_time.includes(":");
    if (!hasTime) {
      if (!errs.includes("expiry_time")) errs.push("expiry_time");
    } else {
      errs = errs.filter(k => k !== "expiry_time");
    }
    if (!editLaserLinkItem?.expire_time_zone) {
      if (!errs.includes("expiry_tz")) errs.push("expiry_tz");
    } else {
      errs = errs.filter(k => k !== "expiry_tz");
    }
  } else {
    errs = errs.filter(k => !["expiry_date","expiry_time","expiry_tz"].includes(k));
  }

  // Invitation code ON ⇒ gate page valid
  if (individualCodeStatus) {
    const page = Number(editLaserLinkItem?.password_page || 0);
    if (!(page > 0 && page <= pages)) {
      if (!errs.includes("password_page")) errs.push("password_page");
    } else {
      errs = errs.filter(k => k !== "password_page");
    }
  } else {
    errs = errs.filter(k => k !== "password_page");
  }

  // Opt-in ON ⇒ either 2nd page OR custom page valid
  if (editLaserLinkItem?.has_optin) {
    const mode = editLaserLinkItem?.opt_in?.optin_mode ||
      (editLaserLinkItem?.optin_2nd_page_viewed ? OPTIN_MODES.SECOND_PAGE : OPTIN_MODES.PAGE_NUMBER);
    if (mode === OPTIN_MODES.PAGES_VIEWED) {
      errs = errs.filter(k => !["optin_show_on_page","optin_show_delay"].includes(k));
      if (!(Number(editLaserLinkItem?.opt_in?.optin_after_pages) >= 1)) {
        if (!errs.includes("optin_after_pages")) errs.push("optin_after_pages");
      } else {
        errs = errs.filter(k => k !== "optin_after_pages");
      }
    } else if (mode === OPTIN_MODES.PAGE_NUMBER) {
      errs = errs.filter(k => k !== "optin_after_pages");
      const page = Number(editLaserLinkItem?.opt_in?.show_on_page || 0);
      if (!(page > 0 && page <= pages)) {
        if (!errs.includes("optin_show_on_page")) errs.push("optin_show_on_page");
      } else {
        errs = errs.filter(k => k !== "optin_show_on_page");
      }
      const delay = editLaserLinkItem?.opt_in?.show_delay;
      const delayNum = (delay === '' || delay === null || delay === undefined) ? 0 : Number(delay);
      if (delayNum < 0) {
        if (!errs.includes("optin_show_delay")) errs.push("optin_show_delay");
      } else {
        errs = errs.filter(k => k !== "optin_show_delay");
      }
    } else {
      // 2nd page mode: clear custom page errors
      errs = errs.filter(k => !["optin_show_on_page","optin_show_delay","optin_after_pages"].includes(k));
    }
  } else {
    // opt-in off ⇒ clear related errors
    errs = errs.filter(k => !["optin_show_on_page","optin_show_delay","optin_after_pages"].includes(k));
  }

  const documentStatus = editLaserLinkItem?.hosted_document?.status;
  const documentMissing =
    !!editLaserLinkItem?.has_optin &&
    !!(editLaserLinkItem?.personal_insights ?? profile?.personal_insights) &&
    editLaserLinkItem?.optin_delivers === "document" &&
    (!editLaserLinkItem?.hosted_document_id || ["rejected", "disabled"].includes(documentStatus));
  errs = errs.filter(k => k !== "optin_document");
  if (documentMissing) errs.push("optin_document");

  const triggerPage = Number(editLaserLinkItem?.guide_trigger_page || 0);
  const triggerPageInvalid =
    !!editLaserLinkItem?.has_optin &&
    !!(editLaserLinkItem?.personal_insights ?? profile?.personal_insights) &&
    ["guide_auto", "guide_review"].includes(editLaserLinkItem?.optin_delivers || "guide_auto") &&
    editLaserLinkItem?.guide_trigger === "page" &&
    !(triggerPage > 0 && (!pages || triggerPage <= pages));
  errs = errs.filter(k => k !== "guide_trigger_page");
  if (triggerPageInvalid) errs.push("guide_trigger_page");

  errs = errs.filter(k => k !== "optin_marketing_text");

  updateErrorStatus(errs);
};

    const handleExpireNow = () => {
        if (!editLaserLinkItem?.expire_time_zone) return;
        const tzObject = time_zone_list?.find(
            (tz) => tz.name === editLaserLinkItem.expire_time_zone
        );
        const tzIdentifier = tzObject?.tzinfo?.info?.identifier;
        if (!tzIdentifier) return;
        const nowInTZ = new Date(
            new Date().toLocaleString("en-US", { timeZone: tzIdentifier })
        );
        const year = nowInTZ.getFullYear();
        const month = String(nowInTZ.getMonth() + 1).padStart(2, "0");
        const day = String(nowInTZ.getDate()).padStart(2, "0");

        const hours = String(nowInTZ.getHours()).padStart(2, "0");
        const minutes = String(nowInTZ.getMinutes()).padStart(2, "0");
        updateEditLaserLinkItem({
            ...editLaserLinkItem,
            expiry: `${year}-${month}-${day}`,
            expire_time: `${hours}:${minutes}`,
        });
        setExpirationDateStatus(true);
    };


  // useEffect(() => {
  //   if (validationTrigger == true) {
  //     validateInnerData();
  //   }
  // }, [validationTrigger])
  useEffect(() => {
    loadGoogleFontsInHtml(editLaserLinkItem?.opt_in?.custom_text);
  }, [editLaserLinkItem?.opt_in?.custom_text]);

  // Validate live (not only on Save) so the tab warning icon and disabled Save reflect errors as the user edits.
  useEffect(() => {
  validateInnerData();
}, [
  validationTrigger,
  getDocFiles,
  profile?.personal_insights,
  individualCodeStatus,
  expirationDateStatus,
  editLaserLinkItem?.expiry,
  editLaserLinkItem?.expire_time_zone,
  editLaserLinkItem?.expire_time,
  editLaserLinkItem?.has_optin,
  editLaserLinkItem?.optin_2nd_page_viewed,
  editLaserLinkItem?.opt_in?.show_on_page,
  editLaserLinkItem?.opt_in?.show_delay,
  editLaserLinkItem?.opt_in?.optin_mode,
  editLaserLinkItem?.opt_in?.optin_after_pages,
  editLaserLinkItem?.password_page,
  editLaserLinkItem?.optin_delivers,
  editLaserLinkItem?.hosted_document_id,
  editLaserLinkItem?.hosted_document?.status,
  editLaserLinkItem?.guide_trigger,
  editLaserLinkItem?.guide_trigger_page
]);


  const updateTestMessageData = async () => {
    try {
      setIsSavingText(true);
      setTemplateSaveState(null);
      let editTextMessageDataCopy = JSON.parse(JSON.stringify(editTextMessageData));
      delete editTextMessageDataCopy.errors;
      let updateMessage = await customAPIRequest('links/default_text.json', 'POST', editTextMessageDataCopy);
      if (updateMessage?.data != undefined) {
        updateDefaultLink(updateMessage?.data?.default_link_texts);
        // Clear the form but stay in edit view
        setEditTextMessageData(null);
        setAccordinActiveKey(null);
        setTemplateSaveState('success');
        setShowNotifications?.({
          showToast: true,
          toastType: 'success',
          toastMessage: 'Text saved successfully. Click Back to return.',
        });
        return true;
      }
      return false;
    } catch (error) {
      setTemplateSaveState('error');
      setShowNotifications?.({
        showToast: true,
        toastType: 'danger',
        toastMessage: 'We could not save this text. Please try again.',
      });
      return false;
    } finally {
      setIsSavingText(false);
    }
  };

  const handeUpdateTextMessage = async () => {
    if (editTextMessageData != null) {
      let errorsData = [];
      if (
        editTextMessageData?.title == "" ||
        editTextMessageData?.title == undefined
      ) {
        errorsData.push("title");
      }
      if (
        editTextMessageData?.message == "" ||
        editTextMessageData?.message == undefined
      ) {
        errorsData.push("message");
      }
      setEditTextMessageData((prevState) => ({
        ...prevState,
        errors: errorsData,
      }));
      if (errorsData?.length == 0) {
        await updateTestMessageData();
      }
    } else {
      setEditTextMessageData({
        title: "",
        message: "",
        errors: ["title", "message"],
      });
    }
  };

  const handleDeleteTextMessageAction = async () => {
    let deleteMessageAction = await networkService(
      `links/delete_default_text/${deleteTextMessage?.id}.json`,
      "DELETE"
    );
    if (deleteMessageAction?.data.status == "ok") {
      updateDefaultLink(deleteMessageAction?.data?.default_link_texts);
      setEditTextMessageData(null);
      setDeleteTextMessage(null);
      setAccordinActiveKey(null);
    }
  };

  const handleSetDefaultTest = async (itemID) => {
    let setDefaultText = await networkService(
      `links/default_text.json`,
      "POST",
      { is_def_txt: true, id: itemID }
    );
    if (setDefaultText?.data.status == "ok") {
      updateDefaultLink(setDefaultText?.data?.default_link_texts);
      setEditTextMessageData(null);
    }
  };
  const optinMode =
    editLaserLinkItem?.opt_in?.optin_mode ||
    (editLaserLinkItem?.optin_2nd_page_viewed ? OPTIN_MODES.SECOND_PAGE : OPTIN_MODES.PAGE_NUMBER);

  const updateOptIn = (patch) =>
    updateEditLaserLinkItem({
      ...editLaserLinkItem,
      opt_in: { ...editLaserLinkItem?.opt_in, ...patch },
    });

  const previewSenderFirstName =
    editLaserLinkItem?.first_name ||
    profile?.first_name ||
    userInfoData?.first_name ||
    userName.split(" ")[0] ||
    "{{sender_first_name}}";
  const previewSenderCompany =
    editLaserLinkItem?.company_name ||
    editLaserLinkItem?.user_company_name ||
    companyName ||
    companyData?.name ||
    previewSenderFirstName;

  const fillPreview = (text) =>
    String(text ?? "")
      .replace(/\{\{\s*sender_first_name\s*\}\}/g, previewSenderFirstName)
      .replace(/\{\{\s*sender_company\s*\}\}/g, previewSenderCompany);

  const personalInsights = !!(editLaserLinkItem?.personal_insights ?? profile?.personal_insights);

  const handleChangeAppearafterRadio = (type) => {
    if (type === OPTIN_MODES.PAGES_VIEWED) {
      updateEditLaserLinkItem({
        ...editLaserLinkItem,
        optin_2nd_page_viewed: false,
        opt_in: {
          ...editLaserLinkItem?.opt_in,
          optin_mode: OPTIN_MODES.PAGES_VIEWED,
          optin_after_pages: Number(editLaserLinkItem?.opt_in?.optin_after_pages) >= 1
            ? Number(editLaserLinkItem?.opt_in?.optin_after_pages)
            : DEFAULT_OPTIN_AFTER_PAGES,
        },
      });
    } else if (type === OPTIN_MODES.SECOND_PAGE) {
      updateEditLaserLinkItem({
        ...editLaserLinkItem,
        optin_2nd_page_viewed: true,
        opt_in: {
          ...editLaserLinkItem?.opt_in,
          optin_mode: OPTIN_MODES.SECOND_PAGE,
          show_on_page: '',
        },
      });
    } else if (type === OPTIN_MODES.PAGE_NUMBER) {
      updateEditLaserLinkItem({
        ...editLaserLinkItem,
        optin_2nd_page_viewed: false,
        opt_in: {
          ...editLaserLinkItem?.opt_in,
          optin_mode: OPTIN_MODES.PAGE_NUMBER,
          show_on_page: editLaserLinkItem?.opt_in?.show_on_page,
          show_delay: editLaserLinkItem?.opt_in?.show_delay ?? 0,
        },
      });
    }
  };

  if (editTextMessage) {
    return (
      <>
        <CommonModal
          title={"Delete Text Message"}
          modalStatus={deleteTextMessage != null}
          changeActiveStatus={() => setDeleteTextMessage(null)}
          centered
          classList={"alert-modal"}
          footer={
            <div className="d-flex m-auto">
              <Button
                text={"No"}
                classList={"alert delete-btn"}
                addonClass={"my-2 mx-2"}
                onClick={() => setDeleteTextMessage(null)}
              />
              <Button
                text={"Yes"}
                classList={"success delete-btn"}
                addonClass={"my-2 mx-2 common-modal-yes-button"}
                onClick={handleDeleteTextMessageAction}
              />
            </div>
          }
        >
          <p style={{ fontSize: "14px" }}>Are you sure?</p>
        </CommonModal>
        <div className="custom-tab-data">
          <p
            className="custom-link-success cursor-pointer back-pop"
            onClick={() => {
              setIsTransitioning(true);
              // Delay to allow TinyMCE to properly cleanup/initialize
              setTimeout(() => {
                setEditTextMessage(false);
                setEditTextMessageData(null);
                setAccordinActiveKey(null);
                setEditorKey(prev => prev + 1);
                setTimeout(() => setIsTransitioning(false), 100);
              }, 50);
            }}
          >
            <FontAwesomeIcon icon={faAngleLeft} /> {isTransitioning ? 'Loading...' : 'Back'}
          </p>
          <Accordion defaultActiveKey="0" activeKey={`${accordinActiveKey}`}>
            <Accordion.Item className="mb-2" eventKey="0">
              <Accordion.Header
                id="cross-drop"
                className="bg-light insert-drop"
                onClick={(e) => {
                  // Don't trigger if clicking the X icon
                  if (!e.target.closest('.accordion-close-icon')) {
                    setAccordinActiveKey(accordinActiveKey === 0 ? null : 0);
                  }
                }}
              >
                <span>
                  Create a New Text Message
                </span>
                <FontAwesomeIcon
                  className="accordion-close-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAccordinActiveKey(null);
                  }}
                  icon={faXmark}
                />
              </Accordion.Header>
              <div className="row">
                <div className="col-md-6">
                  <Accordion.Body className="bg-white message-title-popup">
                    <Input
                      type={"text"}
                      placeholder={"Please enter text title here"}
                      label={"Title:"}
                      value={editTextMessageData?.title ?? ""}
                      onChange={(element) =>
                        setEditTextMessageData((prevState) => ({
                          ...prevState,
                          title: element.target.value,
                        }))
                      }
                      errorMessageStatus={editTextMessageData?.errors?.includes(
                        "title"
                      )}
                      errorMessage={
                        editTextMessageData?.errors?.includes("title") && (
                          <span className="text-danger">Title can't be blank</span>
                        )
                      }
                    />
                    <TextArea
                      placeholder={"Please enter text message here"}
                      label={"Message:"}
                      value={editTextMessageData?.message ?? ""}
                      onChange={(element) =>
                        setEditTextMessageData((prevState) => ({
                          ...prevState,
                          message: element.target.value,
                        }))
                      }
                      errorMessageStatus={editTextMessageData?.errors?.includes(
                        "message"
                      )}
                      errorMessage={
                        editTextMessageData?.errors?.includes("message") && (
                          <span className="text-danger">Message can't be blank</span>
                        )
                      }
                    />
                    <Button
                      classList={`primary laser-link-btn`}
                      className="mb-2 mt-2 save-text-btn"
                      text={
                        templateSaveState === 'success'
                          ? 'Saved!'
                          : templateSaveState === 'error'
                          ? 'Try Again'
                          : isSavingText
                          ? 'Saving...'
                          : 'Save Text'
                      }
                      disabled={isSavingText}
                      onClick={handeUpdateTextMessage}
                    />
                    {templateSaveState === 'success' && (
                      <p className={styles.templateStatusSuccess}>Text saved successfully.</p>
                    )}
                    {templateSaveState === 'error' && (
                      <p className={styles.templateStatusError}>We couldn’t save this text. Please try again.</p>
                    )}
                  </Accordion.Body>
                </div>
              </div>
            </Accordion.Item>
            <Accordion.Item className="mb-2" eventKey="1">
              <Accordion.Header
                id="cross-drop"
                className="bg-light insert-drop"
                onClick={(e) => {
                  // Don't trigger if clicking the X icon
                  if (!e.target.closest('.accordion-close-icon')) {
                    setAccordinActiveKey(accordinActiveKey === 1 ? null : 1);
                  }
                }}
              >
                <span>
                  Existing Text Messages
                </span>
                <FontAwesomeIcon
                  className="accordion-close-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAccordinActiveKey(null);
                  }}
                  icon={faXmark}
                />
              </Accordion.Header>
              <Accordion.Body className="bg-white">
                <Table className="kdf-set-table Existing-text" bordered>
                  <thead>
                    <tr>
                      <th>Set Default</th>
                      <th>Nr.</th>
                      <th>Title</th>
                      <th>Message</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {defaultLinkTexts?.length > 0 ? (
                      defaultLinkTexts?.map((item, index) => (
                        <tr key={item.id}>
                          <td>
                            <input
                              type="radio"
                              name="is_default"
                              value={item.id}
                              checked={item?.is_default ?? false}
                              onChange={(element) =>
                                handleSetDefaultTest(element.target.value)
                              }
                            />
                          </td>
                          <td>{index + 1}</td>
                          <td>{item.title}</td>
                          <td>{item.message}</td>
                          <td>
                            <div className="stats-action-icons">
                              <img
                                src="/icons/edit-blue.svg"
                                alt="Edit"
                                className="stats-action-icon"
                                onClick={() => {
                                  setEditTextMessageData(item);
                                  setAccordinActiveKey(0);
                                }}
                              />
                              <img
                                src="/icons/danger-delete.svg"
                                alt="Delete"
                                className="stats-action-icon"
                                onClick={() => setDeleteTextMessage(item)}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>No data found</tr>
                    )}
                  </tbody>
                </Table>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </>
    );
  }
  const accessControlRows = (
    <>
        <Row className="laser-email-main align-items-center">
          <Col md={3}>
            <CustomTooltip
              title={<p className="p-1 text-light">Use this option to protect your KDF with a password</p>}
            >
              <p>Invitation code</p>
            </CustomTooltip>
          </Col>
          <Col md={9}>
            <div className="d-flex switchs">
              <Switch
                checked={individualCodeStatus}
                onChange={(element) => {
                  if (individualCodeStatus == true) {
                    updateEditLaserLinkItem({
                      ...editLaserLinkItem,
                      password: null,
                      password_page: 1,
                    });
                  }
                  setIndividualCodeStatus(!individualCodeStatus);
                }}
              />
              {individualCodeStatus && (
                <>
                  <CustomTooltip
                    title={
                      <>
                        Invitation code (click{" "}
                        <FontAwesomeIcon icon={faShuffle} /> to generate)
                      </>
                    }
                  >
                    <input
                      type={"text"}
                      placeholder={"Enter your invitation code here"}
                      value={editLaserLinkItem?.password ?? ""}
                      onChange={(element) => {
                        updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          password: element.target.value,
                        });
                      }}
                      className="form-control stuffle-inp"
                    />
                  </CustomTooltip>
                  <div className="d-flex align-items-center mx-2">
                    <span className={styles.gateFieldLabel}>Appear on page:</span>
                    <CustomTooltip
                      title={<p className="p-1 text-light">Please enter a page between 1 and {getDocFiles[0]?.num_pages ?? 0}</p>}
                    >
                      <input
                        className={`edit-box-input mx-2 ${errorListData?.includes("password_page") ? "box-input-error" : ""}`}
                        type="number"
                        value={editLaserLinkItem?.password_page ?? 1}
                        onFocus={(e) => e.target.select()}
                        onChange={(element) => {
                          const value = element.target.value;
                          if (value === '') {
                            updateEditLaserLinkItem({ ...editLaserLinkItem, password_page: '' });
                            return;
                          }
                          const num = Number(value);
                          if (num >= 1 && num <= (getDocFiles[0]?.num_pages ?? Infinity)) {
                            updateEditLaserLinkItem({ ...editLaserLinkItem, password_page: num });
                          }
                        }}
                      />
                    </CustomTooltip>
                  </div>
                  <FontAwesomeIcon
                    icon={faShuffle}
                    className={`btn ${styles.invitationButton}`}
                    onClick={() => {
                      updateEditLaserLinkItem({
                        ...editLaserLinkItem,
                        password: getRandomString(8),
                      });
                    }}
                  />
                </>
              )}
            </div>
            {/* Empty required fields only get a red border; the message is for an entered-but-invalid value. */}
            {individualCodeStatus && errorListData?.includes("password_page") && hasValue(editLaserLinkItem?.password_page) && (
              <small className="text-danger d-block fs-6 mt-1">Page must be between 1 and {getDocFiles[0]?.num_pages ?? 0}.</small>
            )}
          </Col>
        </Row>
        <Row className="laser-email-main mt-3 align-items-center">
          <Col md={3}>
            <p>Expiration date</p>
          </Col>
          <Col md={9} className="d-flex align-items-center">
            <Switch
              checked={expirationDateStatus}
              onChange={() => {
                  const newState = !expirationDateStatus;
                  setExpirationDateStatus(newState);
                  if (!newState) {
                      updateEditLaserLinkItem({
                          ...editLaserLinkItem,
                          expiry: null,
                          expire_time: null,
                          expire_time_zone: null,
                      });
                  }
              }}
            />
            {expirationDateStatus && (
              <div
                id="access-calander"
                className={styles.expirationDateTimeWrapper}
              >
                <CustomTooltip title={<p className="p-1 text-light">Expires on</p>}>
                  {/* <input type="text" value={editLaserLinkItem?.expiry ?? ''} disabled={true} onChange={() => {}} /> */}
                  <input
                    type="date"
                className={`${errorListData?.includes("expiry_date") ? "has-error" : ""}`}
                    value={
                      editLaserLinkItem?.expiry != undefined
                        ? new Date(editLaserLinkItem?.expiry)
                          .toISOString()
                          .split("T")[0]
                        : ""
                    }
                    onChange={(element) => {
                      updateEditLaserLinkItem({
                        ...editLaserLinkItem,
                        expiry: `${new Date(element.target.value)
                          .toISOString()
                          .split("T")[0]
                          }T18:30:00.000Z`,
                        'expire_time': (editLaserLinkItem?.expire_time ?? '0:0')
                      });
                    }}
                    min={new Date().toISOString().split('T')[0]}
                  />
                </CustomTooltip>
                <div className="d-flex align-items-center ms-3 laser-inp">
                  <input
                    className={`edit-value-inp ms-1 me-1 ${errorListData?.includes("expiry_time") ? "has-error" : ""}`}
                    value={
                      editLaserLinkItem?.expire_time != null
                        ? editLaserLinkItem?.expire_time?.split(":")[0]
                        : "00"
                    }
                    onChange={(element) => {
                      let valueToAdd =
                        element?.target?.value != undefined &&
                        (Number(element?.target?.value) <= 0
                          ? "0"
                          : Number(element?.target?.value) >= 23
                            ? "23"
                            : element.target.value);
                      let newValue = `${valueToAdd}:${editLaserLinkItem?.expire_time != null
                        ? editLaserLinkItem?.expire_time?.split(":")[1]
                        : "00"
                        }`;
                      updateEditLaserLinkItem({
                        ...editLaserLinkItem,
                        expire_time: newValue,
                      });
                    }}
                  />
                  <p>:</p>
                  <input
                    className={`edit-value-inp ms-1 me-1 ${errorListData?.includes("expiry_time") ? "has-error" : ""}`}
                    value={
                      editLaserLinkItem?.expire_time != null
                        ? editLaserLinkItem?.expire_time?.split(":")[1]
                        : "00"
                    }
                    onChange={(element) => {
                      let valueToAdd =
                        element?.target?.value != undefined &&
                        (Number(element?.target?.value) <= 0
                          ? "0"
                          : Number(element?.target?.value) >= 59
                            ? "59"
                            : element.target.value);
                      let newValue = `${editLaserLinkItem?.expire_time != null
                        ? editLaserLinkItem?.expire_time?.split(":")[0]
                        : "00"
                        }:${valueToAdd}`;
                      updateEditLaserLinkItem({
                        ...editLaserLinkItem,
                        expire_time: newValue,
                      });
                    }}
                  />
                  <Select
                    optionList={time_zone_list?.map((item) => ({
                      ...item,
                      title: item.name,
                      value: item.name,
                    }))}
                    onChange={(element) =>
                      updateEditLaserLinkItem({
                        ...editLaserLinkItem,
                        expire_time_zone: element.target.value,
                      })
                    }
                    defaultValue={editLaserLinkItem?.expire_time_zone ?? ""}
                    errorMessageStatus={errorListData?.includes("expiry_tz")}
                  />
                    <CustomTooltip
                        title={<p className="p-1 text-light">Expire now</p>}
                    >
                        <FontAwesomeIcon
                            icon={faCalendarXmark}
                            className={`ms-3 cursor-pointer ${styles.expireNowIcon}`}
                            onClick={handleExpireNow}
                        />
                    </CustomTooltip>
                </div>
              </div>
            )}
          </Col>
        </Row>
        {expirationDateStatus && (
          <Row className="laser-email-main mt-3 align-items-center">
              <Col md={3}>
                  <CustomTooltip
                      title={<p className="p-1 text-light">Forward visitors after expiration</p>}
                  >
                      <p>Forward after expiration</p>
                  </CustomTooltip>
              </Col>

              <Col md={9}>
                  <Switch
                      checked={forwardAfterExpirationStatus}
                      onChange={() => {
                          const newState = !forwardAfterExpirationStatus;
                          setForwardAfterExpirationStatus(newState);
                          updateEditLaserLinkItem({
                              ...editLaserLinkItem,
                              forward_settings: {
                                  ...(editLaserLinkItem?.forward_settings || {}),
                                  enabled: newState,
                                  type: newState
                                      ? (editLaserLinkItem?.forward_settings?.type || "url")
                                      : null
                              }
                          });
                      }}
                  />
                  {forwardAfterExpirationStatus && (
                      <div className="mt-3">
                          <div className="d-flex align-items-center mb-2">
                              <input
                                  type="radio"
                                  name="forward_option"
                                  className={styles.forwardRadio}
                                  checked={forwardOptionType === "url"}
                                  onChange={() => {
                                      setForwardOptionType("url");
                                      updateEditLaserLinkItem({
                                          ...editLaserLinkItem,
                                          forward_settings: {
                                              ...(editLaserLinkItem?.forward_settings || {}),
                                              enabled: true,
                                              type: "url"
                                          }
                                      });
                                  }}
                              />
                              <span className={`ms-2 ${styles.forwardRadio}`}>Forward all visitors to a new URL</span>
                              </div>
                              {forwardOptionType === "url" && (
                                  <input
                                      type="text"
                                      className="form-control mb-3"
                                      placeholder="https://example.com"
                                      value={editLaserLinkItem?.forward_settings?.url ?? ""}
                                      onChange={(e) =>
                                          updateEditLaserLinkItem({
                                              ...editLaserLinkItem,
                                              forward_settings: {
                                                  ...(editLaserLinkItem?.forward_settings || {}),
                                                  enabled: true,
                                                  type: "url",
                                                  url: e.target.value
                                              }
                                          })
                                      }
                                  />
                              )}
                              <div className="d-flex align-items-center mb-2">
                                  <input
                                      type="radio"
                                      name="forward_option"
                                      className={styles.forwardRadio}
                                      checked={forwardOptionType === "laserlink"}
                                      onChange={() => {
                                          setForwardOptionType("laserlink");
                                          updateEditLaserLinkItem({
                                              ...editLaserLinkItem,
                                              forward_settings: {
                                                  ...(editLaserLinkItem?.forward_settings || {}),
                                                  enabled: true,
                                                  type: "laserlink"
                                              }
                                          });
                                      }}
                                  />
                                  <span className={`ms-2 ${styles.forwardRadio}`}>Forward all visitors to a different LaserLINK</span>
                              </div>
                              {forwardOptionType === "laserlink" && (
                                  <input
                                      type="text"
                                      className="form-control mb-3"
                                      placeholder="Paste LaserLINK"
                                      value={editLaserLinkItem?.forward_settings?.laserlink ?? ""}
                                      onChange={(e) =>
                                          updateEditLaserLinkItem({
                                              ...editLaserLinkItem,
                                              forward_settings: {
                                                  ...(editLaserLinkItem?.forward_settings || {}),
                                                  enabled: true,
                                                  type: "laserlink",
                                                  laserlink: e.target.value
                                              }
                                          })
                                      }
                                  />
                              )}
                              <div className="d-flex align-items-center mb-2">
                                  <input
                                      type="radio"
                                      name="forward_option"
                                      className={styles.forwardRadio}
                                      checked={forwardOptionType === "error"}
                                      onChange={() => {
                                          setForwardOptionType("error");
                                          updateEditLaserLinkItem({
                                              ...editLaserLinkItem,
                                              forward_settings: {
                                                  ...(editLaserLinkItem?.forward_settings || {}),
                                                  enabled: true,
                                                  type: "error",
                                                  error_text:
                                                      editLaserLinkItem?.forward_settings?.error_text ?? DEFAULT_ERROR_TEXT
                                              }
                                          });

                                      }}
                                  />
                                  <span className={`ms-2 ${styles.forwardRadio}`}>Present the new error message</span>
                              </div>
                              {forwardOptionType === "error" && (
                                  <TextArea
                                      value={ editLaserLinkItem?.forward_settings?.error_text ?? DEFAULT_ERROR_TEXT }
                                      onChange={(e) =>
                                          updateEditLaserLinkItem({
                                              ...editLaserLinkItem,
                                              forward_settings: {
                                                  ...(editLaserLinkItem?.forward_settings || {}),
                                                  enabled: true,
                                                  type: "error",
                                                  error_text: e.target.value
                                              }
                                          })
                                      }
                                  />

                              )}
                          </div>
                      )}
                  </Col>
              </Row>
          )}
    </>
  );

  if (personalInsights) {
    return (
      <div className="laser-popup-pages">
        <PersonalInsightsOptinSettings
          editLaserLinkItem={editLaserLinkItem}
          updateEditLaserLinkItem={updateEditLaserLinkItem}
          profile={profile}
          fillPreview={fillPreview}
          ownerEmail={userInfoData?.email}
          documentError={errorListData?.includes("optin_document")}
          triggerPageError={errorListData?.includes("guide_trigger_page")}
          afterPagesError={errorListData?.includes("optin_after_pages")}
          totalPages={getDocFiles?.[0]?.num_pages || 0}
          accessControls={<div className="laser-top">{accessControlRows}</div>}
        />
      </div>
    );
  }

  return (
    <div className="laser-popup-pages">
      <div className="laser-top">
        {accessControlRows}
        <Row className="laser-email-main mt-3 align-items-center">
          <Col md={3}>
            <p>Enable opt-in</p>
          </Col>
          <Col md={9} className="d-flex justify-content-between">
            <Switch
              checked={editLaserLinkItem?.has_optin ?? false}
              onChange={() =>
                updateEditLaserLinkItem({
                  ...editLaserLinkItem,
                  has_optin: !editLaserLinkItem?.has_optin,
                })
              }
            />
            {!!editLaserLinkItem?.has_optin && (
              <div className="d-flex">
                <div className="d-flex align-items-center">
                  <label className="mx-2 mb-0">Last name</label>
                  <Switch
                    checked={editLaserLinkItem?.opt_in?.ask_last_name ?? false}
                    onChange={() => updateOptIn({ ask_last_name: !editLaserLinkItem?.opt_in?.ask_last_name })}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <label className="mx-2 mb-0">Tel nr.</label>
                  <Switch
                    checked={editLaserLinkItem?.opt_in?.ask_telephone_number ?? false}
                    onChange={() => updateOptIn({ ask_telephone_number: !editLaserLinkItem?.opt_in?.ask_telephone_number })}
                  />
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {!!editLaserLinkItem?.has_optin && (
        <>
          <Row>
            <Col md={12}>
              <div className={styles.optinSectionHeaderB}>
                <h6 className={styles.optinTitle}>OPT-IN Settings</h6>
                {!!companyName && (
                  <p className={styles.companySubtitle}>Company: {companyName}</p>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex">
                <Switch
                  className="apper-page"
                  checked={optinMode === OPTIN_MODES.PAGES_VIEWED}
                  onChange={() => handleChangeAppearafterRadio(OPTIN_MODES.PAGES_VIEWED)}
                  formLabel={
                    <span className="cursor-pointer">
                      Ask for opt-in after &nbsp;
                      <input
                        className={`edit-box-input ${errorListData?.includes("optin_after_pages") ? "box-input-error" : ""}`}
                        type="number"
                        min="1"
                        value={editLaserLinkItem?.opt_in?.optin_after_pages ?? DEFAULT_OPTIN_AFTER_PAGES}
                        onFocus={(e) => e.target.select()}
                        onChange={(element) => {
                          const inputValue = element.target.value;
                          updateEditLaserLinkItem({
                            ...editLaserLinkItem,
                            optin_2nd_page_viewed: false,
                            opt_in: {
                              ...editLaserLinkItem?.opt_in,
                              optin_mode: OPTIN_MODES.PAGES_VIEWED,
                              optin_after_pages: inputValue === '' ? '' : Number(inputValue),
                            },
                          });
                        }}
                        onBlur={(e) => {
                          if (!(Number(e.target.value) >= 1)) updateOptIn({ optin_after_pages: DEFAULT_OPTIN_AFTER_PAGES });
                        }}
                      />
                      &nbsp; pages viewed
                    </span>
                  }
                  type="radio"
                  name="optin_page"
                  id="optin_page_pages_viewed"
                />
              </div>
              {errorListData?.includes("optin_after_pages") && hasValue(editLaserLinkItem?.opt_in?.optin_after_pages) && (
                <small className="text-danger d-block fs-6 mt-1">Enter 1 or more pages.</small>
              )}
              <div className="d-flex">
                <Switch
                  className="apper-page"
                  checked={optinMode === OPTIN_MODES.SECOND_PAGE}
                  onChange={() => handleChangeAppearafterRadio(OPTIN_MODES.SECOND_PAGE)}
                  formLabel={
                    <span className="cursor-pointer">
                      Appear on {getDocFiles[0]?.num_pages <= 3 ? getDocFiles[0]?.num_pages : 3}
                      <sup>rd</sup> viewed page
                    </span>
                  }
                  type="radio"
                  name="optin_page"
                  id="optin_page_2nd"
                />
              </div>
              <div className="d-flex">
                <Switch
                  className="apper-after"
                  checked={optinMode === OPTIN_MODES.PAGE_NUMBER}
                  onChange={() => handleChangeAppearafterRadio(OPTIN_MODES.PAGE_NUMBER)}
                  type="radio"
                  name="optin_page"
                  id='notify-kdf-radio-after_seconds'
                  formLabel={
                    <span className="cursor-pointer">
                      Appear on page: &nbsp;
                      <CustomTooltip
                        title={<p className="p-1 text-light">Please enter a page between 1 and {getDocFiles[0]?.num_pages ?? 0
                        }</p>}
                      >
                        <input
                          className={`edit-box-input ${errorListData?.includes("optin_show_on_page") ? "box-input-error" : ""}`}
                          type="number"
                          value={editLaserLinkItem?.opt_in?.show_on_page ?? ''}
                          onFocus={(e) => e.target.select()}
                          onChange={(element) => {
                            if (element.target.value <= getDocFiles[0]?.num_pages) {
                              updateEditLaserLinkItem({
                                ...editLaserLinkItem,
                                optin_2nd_page_viewed: false,
                                opt_in: {
                                  ...editLaserLinkItem?.opt_in,
                                  optin_mode: OPTIN_MODES.PAGE_NUMBER,
                                  show_on_page: element.target.value,
                                },
                              });
                            }
                          }}
                        />
                      </CustomTooltip> &nbsp;
                      / {getDocFiles[0]?.num_pages ?? 0} after &nbsp;
                      <CustomTooltip title={<p className="p-1 text-light">Please enter the time in seconds</p>}>
                        <input
                          className={`edit-box-input ${errorListData?.includes("optin_show_delay") ? "box-input-error" : ""}`}
                          type="number"
                          min="0"
                          value={editLaserLinkItem?.opt_in?.show_delay ?? 0}
                          onFocus={(e) => e.target.select()}
                          onChange={(element) => {
                            const inputValue = element.target.value;
                            if (inputValue === '' || Number(inputValue) >= 0) {
                              updateOptIn({ show_delay: inputValue === '' ? '' : Number(inputValue) });
                            }
                          }}
                          onBlur={(e) => {
                            if (e.target.value === '' || e.target.value === null) {
                              updateOptIn({ show_delay: 0 });
                            }
                          }}
                        />
                      </CustomTooltip> &nbsp;
                      {Number(editLaserLinkItem?.opt_in?.show_delay ?? 0) === 1 ? "second" : "seconds"}
                    </span>
                  }
                />
              </div>
              {errorListData?.includes("optin_show_on_page") && hasValue(editLaserLinkItem?.opt_in?.show_on_page) && (
                <small className="text-danger d-block mt-1">Page must be between 1 and {getDocFiles[0]?.num_pages ?? 0}.</small>
              )}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <div className="d-flex align-items-center edit-msg-access mb-3 mt-3 gap-2">
                <Select
                  placeholder={"Select a text template"}
                  optionList={defaultLinkTexts?.map((item) => ({
                    ...item,
                    value: item.title,
                  }))}
                  defaultValue={
                    !!editLaserLinkItem?.opt_in?.custom_text
                      ? defaultLinkTexts?.find(
                        (item) =>
                          editLaserLinkItem?.opt_in?.custom_text?.includes(item.message)
                      )?.title
                      : ""
                  }
                  onChange={(element) => {
                    let valueToUpdate = defaultLinkTexts?.find(
                      (item) => item.title == element.target.value
                    );
                    if (valueToUpdate) {
                      updateOptIn({
                        custom_text: valueToUpdate?.message,
                        custom_subsequent_text:
                          valueToUpdate?.subsequent_message ?? valueToUpdate?.message,
                      });
                      setEditorKey(prev => prev + 1);
                    }
                  }}
                />
                <div className="d-flex align-items-center gap-2">
                <button
                  type="button"
                  className={styles.templateLinkButton}
                  onClick={() => {
                    setEditTextMessage(true);
                    setAccordinActiveKey(0);
                    setEditTextMessageData(null);
                  }}
                >
                  Click here for predefined text template
                </button>
                <CustomTooltip title={<p className="p-1 text-light">Add / Edit text message</p>}>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className="cursor-poiner"
                    onClick={() => {
                      setEditTextMessage(true);
                      setAccordinActiveKey(0);
                      setEditTextMessageData(null);
                    }}
                  />
                </CustomTooltip>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={7}>
              <label className={styles.buttonTextLabelB}>Headline:</label>
              <Input
                classList="kz-optin-headline-input"
                value={editLaserLinkItem?.opt_in?.headline || DEFAULT_OPTIN_HEADLINE}
                maxLength={150}
                onChange={(element) => updateOptIn({ headline: element.target.value })}
              />
              <label className={`${styles.buttonTextLabelB} mt-2`}>Benefit line:</label>
              {!isTransitioning && (
                <div className="option-editor-wrapper">
                  <TextEditorSection
                    key={`text-editor-${customTextScope}-${editorKey}`}
                    height={340}
                    html_text={editLaserLinkItem?.opt_in?.custom_text || getOptInCopy(editLaserLinkItem?.opt_in).benefit}
                    handleTextChange={(e) => updateOptIn({ custom_text: e })}
                  />
                </div>
              )}
              <p className="text-muted small mt-2 mb-2">
                {"{{sender_first_name}}"} and {"{{sender_company}}"} are filled in from your account. The disclosure sentence, the mailing-list line, the Continue button and the privacy footer are fixed.
              </p>
              <Switch
                className="checkbox-access-box mt-2 align-items-center d-flex gap-2"
                formLabel={'Show "Continue without sharing"'}
                type="checkbox"
                checked={!!editLaserLinkItem?.opt_in?.allow_continue_without_sharing}
                onChange={() => updateOptIn({ allow_continue_without_sharing: !editLaserLinkItem?.opt_in?.allow_continue_without_sharing })}
              />
            </Col>
            <Col md={5}>
              <div className="permission-para kz-optin-preview">
                <p className="kz-optin-preview__headline">{fillPreview(editLaserLinkItem?.opt_in?.headline?.trim() || DEFAULT_OPTIN_HEADLINE)}</p>
                <section
                  className="kz-optin-preview__text"
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(fillPreview(editLaserLinkItem?.opt_in?.custom_text || getOptInCopy(editLaserLinkItem?.opt_in).benefit)),
                  }}
                ></section>
                {getOptInCopy(editLaserLinkItem?.opt_in).mailingInline ? (
                  <p className="kz-optin-preview__text">
                    {fillPreview(getOptInCopy(editLaserLinkItem?.opt_in).disclosure)}{" "}{OPTIN_NOT_A_MAILING_LIST}
                  </p>
                ) : (
                  <>
                    <p className="kz-optin-preview__text">{fillPreview(getOptInCopy(editLaserLinkItem?.opt_in).disclosure)}</p>
                    <p className="kz-optin-preview__text kz-optin-preview__mailing">{OPTIN_NOT_A_MAILING_LIST}</p>
                  </>
                )}
                {getOptInCopy(editLaserLinkItem?.opt_in).fieldsLabel && (
                  <p className="kz-optin-preview__text kz-optin-preview__mailing">{getOptInCopy(editLaserLinkItem?.opt_in).fieldsLabel}</p>
                )}
                <Input readOnly={true} placeholder={"First name"} />
                {editLaserLinkItem?.opt_in?.ask_last_name && (
                  <div style={{ marginTop: '12px' }}>
                    <Input readOnly={true} placeholder={"Last name"} />
                  </div>
                )}
                <div style={{ marginTop: '12px' }}>
                  <Input readOnly={true} placeholder={"Work email"} />
                </div>
                {editLaserLinkItem?.opt_in?.ask_telephone_number && (
                  <div style={{ marginTop: '12px' }}>
                    <Input readOnly={true} placeholder={"Tel nr."} />
                  </div>
                )}
                <div className="kz-optin-preview__actions">
                  <button type="button" className="kz-optin-preview__continue">Continue</button>
                  {editLaserLinkItem?.opt_in?.allow_continue_without_sharing && (
                    <span className="kz-optin-preview__skip">Continue without sharing</span>
                  )}
                </div>
                <p className="kz-optin-preview__footer">
                  {fillPreview(getOptInCopy(editLaserLinkItem?.opt_in).footer)}{" "}
                  <a href={resolvePrivacyUrl(profile?.privacy_link)} target="_blank" rel="noopener noreferrer">Privacy Notice</a>
                </p>
              </div>
            </Col>
          </Row>
        </>
      )}

    </div>
  );
}
export default AccessGateOptionsTab;
